/** @jsx jsx */
import { useEffect, useState } from 'react';
import { jsx } from '@emotion/react';
import { Alert, Link } from '@zapier/design-system';

import type { ResponseData } from '../useAlertBanner/useAlertBannerData';

const ALL_SALES_FINAL_DISMISSED_KEY = 'allSalesFinalDismissedOn';

export const shouldRender = (data: ResponseData) => {
  const { currentAccount, currentUser, allSalesFinal } = data;
  const hasDismissedAllSalesFinal =
    localStorage.getItem(ALL_SALES_FINAL_DISMISSED_KEY) !== null;

  return (
    currentUser.isLoggedIn &&
    (allSalesFinal === 'on' || allSalesFinal === 'prelaunch') &&
    !hasDismissedAllSalesFinal &&
    currentAccount.currentUserRole != 'member' &&
    !currentAccount.isEnterpriseAccount
  );
};

export const Component = function AllSalesFinalTermsOfService() {
  const [allSalesFinalDismissedOn, setAllSalesFinalDismissedOn] = useState(
    localStorage.getItem(ALL_SALES_FINAL_DISMISSED_KEY)
  );

  useEffect(() => {
    if (allSalesFinalDismissedOn !== null) {
      // Wrap localStorage write in try/catch in case browser memory quota is exceeded
      try {
        localStorage.setItem(
          ALL_SALES_FINAL_DISMISSED_KEY,
          allSalesFinalDismissedOn
        );
      } catch {
        console.log('Failed to save allSalesFinalDismissedOn to localStorage');
      }
    }
  }, [allSalesFinalDismissedOn]);

  const onDismiss = () => {
    setAllSalesFinalDismissedOn(new Date().toUTCString());
  };

  const title = (
    <span data-zds>
      Our{' '}
      <Link
        href="https://help.zapier.com/hc/en-us/articles/8496260621197-Zapier-s-refund-policy"
        target="_blank"
      >
        Refund Policy
      </Link>{' '}
      is changing on August 30, 2024.
    </span>
  );

  if (allSalesFinalDismissedOn) {
    return null;
  }

  return (
    <Alert layout="banner" onDismiss={onDismiss} title={title} type="info" />
  );
};
